import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useContext, useEffect, useState } from "react";
import * as Fi from "react-icons/fi";
import Utils from "../../utils/Utils";
import { AppContext } from "../../context/AppContext";
import { toast } from "react-toastify";

function ReservationMessages({
  reservDetails,
  id,
  messageList,
  getNewMessages,
}) {
  const { sendNewMessage, messageLoading, tokenData } = useContext(AppContext);

  const [message, setMessage] = useState("");

  const sendMessage = async (e) => {
    e.preventDefault();
    const headers = { "x-shopToken": tokenData?.shopCustomToken };
    const payload = {
      reservationId: id,
      message: message,
      source: "NextJs",
    };

    await sendNewMessage(payload, {
      onSuccess: async (res) => {
        if (res?.data) {
          toast.success("Message send to customer successfully!");
          await getNewMessages();
          setMessage("");
        }
      },
      onFailed: (err) => {
        console.log("message send failed!");
      },
      headers: headers,
    });
  };
console.log(reservDetails, "reservDetails");
  return (
    <>
      <div className="messages_wrapper">
        <div className="message_head">
          <p>
            <span>Reservation ID</span> {reservDetails?.formattedID ?? "N/A"}
          </p>
          <p>
            <span>Name</span> {reservDetails?.name ?? "N/A"}
          </p>
          <p>
            <span>Phone</span> {reservDetails?.phone ?? "N/A"}
          </p>
          <p>
            <span>Email</span> {reservDetails?.email ?? "N/A"}
          </p>
          <p>
            <span>Party Size</span> {reservDetails?.chairs ?? "N/A"}
          </p>
          <p>
            <span>Appoinment Date</span>{" "}
            {reservDetails?.bookingDate
              ? Utils.formatDate(reservDetails?.bookingDate)
              : "N/A"}
          </p>
          <p>
            <span>Appoinment Time</span>{" "}
            {reservDetails?.bookingTime
              ? Utils.convertTiming(reservDetails?.bookingTime)
              : "N/A"}
          </p>
        </div>
        <hr />
        <div className="message_area">
          <div class="chat-container">
            {messageList &&
              messageList.length != 0 &&
              messageList.map((msg, index) => {
                const [date, time] = msg?.addedTime.split(" ");

                if (msg?.auther == "shop") {
                  return (
                    <div class="message sender">
                      <span> {msg?.message}</span>
                      <p className="text-light">
                        {date ? Utils.formatDate(date) : "N/A"} |{" "}
                        {time ? Utils.convertTiming(time) : "N/A"}
                      </p>
                    </div>
                  );
                }
                if (msg?.auther == "customer") {
                  return (
                    <div class="message receiver ">
                      <span> {msg?.message}</span>
                      <p>
                        {date ? Utils.formatDate(date) : "N/A"} |{" "}
                        {time ? Utils.convertTiming(time) : "N/A"}
                      </p>
                    </div>
                  );
                }
              })}
          </div>
        </div>
      </div>

      <form className="send_message_form" onSubmit={sendMessage}>
        <div className="searc_area d-flex">
          <input
            type="text"
            name=""
            id=""
            className="form-control"
            placeholder="Write Message.."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <button
            type="submit"
            className="send_message_btn"
            disabled={messageLoading}
          >
            {messageLoading ? (
              <div class="spinner-border text-danger" role="status"></div>
            ) : (
              <i>
                <Fi.FiSend />
              </i>
            )}
          </button>
        </div>
      </form>
    </>
  );
}

export default ReservationMessages;
